import { __assign, __extends } from "tslib";
import React from 'react';
import { TextInput } from 'react-native';
import { formatDollar } from '../utils.js';
var DollarInput = /** @class */function (_super) {
  __extends(DollarInput, _super);
  function DollarInput(props) {
    var _this = _super.call(this, props) || this;
    _this.state = _this.valObj(props.value);
    _this.onChangeText = _this.onChangeText.bind(_this);
    return _this;
  }
  DollarInput.prototype.removeNonNumeric = function (val) {
    if (typeof val === "string") {
      return parseInt(String(val).replace(/\D/g, '')) / 100;
    }
    return val;
  };
  DollarInput.prototype.componentWillReceiveProps = function (newProps) {
    if (newProps.value === this.state.value) return;
    this.setValue(newProps.value);
  };
  DollarInput.prototype.onChangeText = function (val) {
    var _val = this.removeNonNumeric(val);
    this.setValue(_val);
    this.props.onChangeText(_val);
  };
  DollarInput.prototype.setValue = function (val) {
    this.setState(this.valObj(val));
  };
  DollarInput.prototype.valObj = function (val) {
    var _val = this.removeNonNumeric(val);
    return {
      value: _val,
      formattedValue: formatDollar(_val)
    };
  };
  DollarInput.prototype.render = function () {
    return /*#__PURE__*/React.createElement(TextInput, __assign({}, this.props, {
      onChangeText: this.onChangeText,
      value: this.state.formattedValue
    }));
  };
  return DollarInput;
}(React.Component);
export default DollarInput;